import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { logger } from '../../core';
import LoginForm from './components/LoginForm';
import RegisterForm from './components/RegisterForm';
import ForgotPasswordForm from './components/ForgotPasswordForm';
import ResetPasswordForm from './components/ResetPasswordForm';
import VerifyEmail from './components/VerifyEmail';

export function AuthSection() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { switchToAccount } = useAuth();

  const urlView = searchParams.get('view');
  const switchToAccountId = searchParams.get('switchToAccount');
  const redirectTo = searchParams.get('redirectTo') || '/main';
  const [view, setView] = useState(urlView || 'login'); // 'login', 'register', 'forgot', 'reset', 'verify', 'accept-invite'

  useEffect(() => {
    if (urlView) {
      setView(urlView);
    }
  }, [urlView]);

  // Handle account switching via URL parameter
  useEffect(() => {
    if (switchToAccountId) {
      const handleAccountSwitch = async () => {
        logger.log({
          tags: 'auth|account-switch',
          color1: 'blue'
        }, `Attempting to switch to account: ${switchToAccountId}`);

        const result = await switchToAccount(switchToAccountId);
        if (result.success) {
          // Successfully switched account, navigate to the specified redirect location
          navigate(redirectTo, { replace: true });
        } else {
          logger.error({
            tags: 'auth|account-switch',
            color1: 'red'
          }, `Failed to switch to account ${switchToAccountId}:`, result.error);
          // Stay on auth page but remove the switch parameter
          navigate('/auth', { replace: true });
        }
      };

      handleAccountSwitch();
    }
  }, [switchToAccountId, switchToAccount, navigate, redirectTo]);

  const switchToLogin = () => setView('login');
  const switchToRegister = () => setView('register');
  const switchToForgot = () => setView('forgot');

  const REVOLT_LOGO_URL = 'https://bluedrake42.nyc3.cdn.digitaloceanspaces.com/revolt-site/site-assets/logo/revolt-logo-small-transparent.png';

  return (
    <div className="auth-section">
      <div className="auth-container">
        <Link
          to="/main"
          className="auth-container__home-link"
          data-navigation-button
        >
          <img
            src={REVOLT_LOGO_URL}
            alt=""
            className="auth-container__home-link-logo"
            aria-hidden
          />
          <span className="auth-container__home-link-text">Back to home</span>
        </Link>
        {view === 'verify' ? (
          <VerifyEmail />
        ) : view === 'reset' ? (
          <ResetPasswordForm />
        ) : view === 'forgot' ? (
          <ForgotPasswordForm onSwitchToLogin={switchToLogin} />
        ) : view === 'login' ? (
          <LoginForm onSwitchToRegister={switchToRegister} onSwitchToForgot={switchToForgot} />
        ) : (
          <RegisterForm onSwitchToLogin={switchToLogin} />
        )}
      </div>
    </div>
  );
}
